import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { NavLink } from "react-router-dom";

const PricingSection = () => {
  const sectionRef = useRef(null);
  
  // Check if the section is in view
  const isInView = useInView(sectionRef, { once: false });

  // Animation variants for fade-in and scale effect
  const fadeInVariants = {
    hidden: { opacity: 0, scale: 0.8 }, // Start hidden and slightly smaller
    visible: {
      opacity: 1,
      scale: 1, // Grow to normal size
      transition: {
        duration: 1, // Slow transition duration
        ease: "easeOut", // Ease out for a smooth transition
      },
    },
  };

  return (
    <section className="pricing_section section_space" style={{overflow: "hidden"}}>
      <div className="container">
        <motion.div
          ref={sectionRef} // Reference for the useInView hook
          initial="hidden" // Initial hidden state
          animate={isInView ? "visible" : "hidden"} // Animate when in view
          variants={fadeInVariants} // Apply fade and scale variants
          className="heading_block style_2 text-center"
        >
          <div className="badge style_2 text-uppercase">
            <i className="fa-solid fa-circle text-primary"></i>Membership Fees
            <i className="fa-solid fa-circle text-primary"></i>
          </div>
          <h2 className="heading_text mb-0"> Join the MSB Association today </h2>
        </motion.div>
        
        {/* Row with two pricing cards */}
        <motion.div
          ref={sectionRef} // Reference for the useInView hook
          initial="hidden" // Initial hidden state
          animate={isInView ? "visible" : "hidden"} // Animate when in view
          variants={fadeInVariants} // Apply fade and scale variants
          className="row"
        >
          {/* General Pricing Block */}
          <div className="col-lg-12">
            <div className="ps_pricing_block bg-grd" style={{alignItems: 'center'}}>
              <div className="pricing_description">
                <h3 className="pricing_title">General Membership</h3>
                <p>Access to key benefits and services as part of our MSB Association.</p>
                <ul className="iconlist_block unordered_list_block">
                  <li>
                    <span className="iconlist_icon">
                      <i className="fa-solid fa-circle" />
                    </span>
                    <span className="iconlist_text">
                      Comprehensive industry updates and compliance support.
                    </span>
                  </li>
                  <li>
                    <span className="iconlist_icon">
                      <i className="fa-solid fa-circle" />
                    </span>
                    <span className="iconlist_text">
                      Networking opportunities with other MSB professionals.
                    </span>
                  </li>
                </ul>
                <NavLink
                  className="btn bg-primary text-dark btn-rounded"
                  to="/overview#membership-form"
                >
                  <span className="btn_label">Become a Member</span>
                  <span className="btn_icon">
                    <svg
                      width={20}
                      height={16}
                      viewBox="0 0 20 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19.7071 8.70711C20.0976 8.31658 20.0976 7.68342 19.7071 7.29289L13.3431 0.928932C12.9526 0.538408 12.3195 0.538408 11.9289 0.928932C11.5384 1.31946 11.5384 1.95262 11.9289 2.34315L17.5858 8L11.9289 13.6569C11.5384 14.0474 11.5384 14.6805 11.9289 15.0711C12.3195 15.4616 12.9526 15.4616 13.3431 15.0711L19.7071 8.70711ZM0 9H19V7H0V9Z"
                        fill="black"
                      />
                    </svg>
                  </span>
                </NavLink>
              </div>
              <ul className="pricing_feature_list text-center unordered_list_block">
                <li>
                  <p className="mb-2" style={{fontSize:'18px', position: 'relative'}}>Membership Fee <span className="badage-pricing" >MSBs'</span></p>
                  <div className="price_value">£ 199  <span style={{fontSize:'13px'}}>/ Year</span></div>
                </li>
                {/* <li>
                  <p className="mb-0">
                  Includes 1 Branch
                  </p>
                </li> */}
                {/* <li>
                  <p className="mb-0">Upto 5 Employees</p>
                </li> */}
              </ul>
              <ul className="pricing_feature_list text-center unordered_list_block">
                <li>
                  <p className="mb-2" style={{fontSize:'18px', position: 'relative'}}>Membership Fee  <span className="badage-pricing2" >Affiliates</span></p>
                  <div className="price_value"> £ 799  <span style={{fontSize:'13px'}}>/ Year</span></div>
                </li>
                {/* <li>
                  <p className="mb-0">
                   Includes 2 or More Branches
                  </p>
                </li> */}
                {/* <li>
                  <p className="mb-0">More than 5 Employees</p>
                </li> */}
              </ul>

        
            </div>
          </div>

       
        </motion.div>
      </div>
    </section>
  );
};

export default PricingSection;
